import { render } from "./clientTypePortal.vue?vue&type=template&id=978d7e38&scoped=true"
import script from "./clientTypePortal.vue?vue&type=script&lang=js"
export * from "./clientTypePortal.vue?vue&type=script&lang=js"

import "./clientTypePortal.vue?vue&type=style&index=0&id=978d7e38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978d7e38"]])

export default __exports__